var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"registrations-header page-heading"},[_c('b-row',[_c('b-col',{attrs:{"md":"5"}},[_c('div',{staticClass:"heading28"},[_vm._v("TCS Registration Requests")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }